import { getStore } from 'core_main/store';

export const getUnreadCount = () => {
  const store = getStore();

  return store.unreadCounts;
};
